import { render, staticRenderFns } from "./Date.vue?vue&type=template&id=a5e46e4a&scoped=true&"
import script from "./Date.vue?vue&type=script&lang=js&"
export * from "./Date.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5e46e4a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/frontend/data/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a5e46e4a')) {
      api.createRecord('a5e46e4a', component.options)
    } else {
      api.reload('a5e46e4a', component.options)
    }
    module.hot.accept("./Date.vue?vue&type=template&id=a5e46e4a&scoped=true&", function () {
      api.rerender('a5e46e4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Filters/Date.vue"
export default component.exports